var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"markdown",domProps:{"innerHTML":_vm._s(_vm.convertedHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }